const HeaderLogo = ({ imgSrc, className, ...rest }) => {
  return (
    <div
      {...rest}
      className={`flex items-center justify-items-start h-16 py-0 px-0 mr-6 ${className}`}
    >
      <img src={imgSrc} alt="logo" className="p-2 object-fill h-full " />
    </div>
  );
};

export default HeaderLogo;
